// Owner-supplied contact details and assets.
export const site = {
  name: 'Vijeesh Thattante Valappil',
  portfolioPath: '/portfolio',
  resumeUrl: 'https://customer-assets-lqy194kg.emergentagent.net/job_portfolio-landing-96/artifacts/b1343728d908ea96_Vijeesh_Resume.pdf',
  phone: '+971509045108',
  email: 'vijeesh91@gmail.com',
  background: 'https://customer-assets-cm19k8pv.emergentagent.net/job_2ec803a4-e045-448b-8706-a81a2f68338d/artifacts/rl01xy6f_Background%20Image%20full%20size.webp',
  title: 'https://customer-assets-cm19k8pv.emergentagent.net/job_2ec803a4-e045-448b-8706-a81a2f68338d/artifacts/fyy86lt7_VIJEESH%20THATTANTE%20VALAPPIL.png',
};

export const revealEase = [0.22, 1, 0.36, 1];